import gql from 'graphql-tag';

const unarchiveAssetMutation = gql`
    mutation UnarchiveAssetMutation($assetId: String!) {
        unarchiveAsset(assetId: $assetId) {
            assetId
        }
    }
`;

export default (() => ({
  mutation: unarchiveAssetMutation,
  module: 'assets',
  buildVariables: (assetId) => ({
    assetId
  })
}));